/*
 *
 * Do not edit directly
 * Generated on Mon, 24 Jun 2024 16:18:26 GMT
 *
 */


const theme = {
  appearances: { size: { type: 'variant', values: [ 'mini' ] } },
  rules: [ { if: { size: 'mini' }, tokens: { height: 8 } } ],
  tokens: {
    backgroundColor: '#f4f4f7',
    borderColor: '#b2b9bf',
    borderRadius: 12,
    borderWidth: 1,
    height: 16
  }
}
export default theme
